import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
import { escapeRegExp, stripTags } from 'sh-www/utils/misc';

/**
 * Returns a modified version of `string` where all instances of `highlightString` are wrapped in
 * <span> tags for styling purposes.
 *
 * @param {String} string
 * @param {String} highlightString
 * @returns {string}
 */
export const highlightMatches = ([string, highlightString]) => {
  // this is just completely busted, disabling it for now
  return string;

  // if (!highlightString) {
  //   return htmlSafe(string);
  // }
  //
  // const html = string.replace(
  //   new RegExp(`(\\b${stripTags(escapeRegExp(highlightString))})`, 'ig'),
  //   '<span class="signup-input__option-highlight">$1</span>',
  // );
  //
  // return htmlSafe(html);
};

export default buildHelper(highlightMatches);
